export class OrderItemInfoModel {
    order_code: string
    vendor: string
    vendor_code: string
    container_cost: number
    container_type: string
    unit_per_issue: number
    method_of_issue: string
    issue_container: string
    unit_per_container: number
    order_no: number
    vendor_name: string

    constructor(
        order_code: string,
        vendor: string,
        vendor_code: string,
        container_cost: number,
        container_type: string,
        unit_per_issue: number,
        method_of_issue: string,
        issue_container: string,
        unit_per_container: number,
        order_no: number,
        vendor_name: string
    ) {
        this.order_code = order_code
        this.vendor = vendor
        this.vendor_code = vendor_code
        this.container_cost = container_cost
        this.container_type = container_type
        this.unit_per_issue = unit_per_issue
        this.method_of_issue = method_of_issue
        this.issue_container = issue_container
        this.unit_per_container = unit_per_container
        this.order_no = order_no
        this.vendor_name = vendor_name
    }
}